import { render } from "./importProfile.vue?vue&type=template&id=fd3cf210&scoped=true"
import script from "./importProfile.vue?vue&type=script&lang=js"
export * from "./importProfile.vue?vue&type=script&lang=js"

import "./importProfile.vue?vue&type=style&index=0&id=fd3cf210&style=scss&scoped=true&lang=css"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd3cf210"],['__file',"src/views/people/profile/importProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd3cf210"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd3cf210', __exports__)) {
    console.log('reload')
    api.reload('fd3cf210', __exports__)
  }
  
  module.hot.accept("./importProfile.vue?vue&type=template&id=fd3cf210&scoped=true", () => {
    console.log('re-render')
    api.rerender('fd3cf210', render)
  })

}


export default __exports__